// TODO: Need to have a default pattern between eslint from Customer and Service
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum BatchStatusEnum {
  COMPLETED = 'COMPLETED',
  CONCLUDED = 'CONCLUDED',
  CANCELLED = 'CANCELLED',
  IN_OPERATION = 'IN_OPERATION',
  STOPPED = 'STOPPED',
  LOADING = 'LOADING',
  COMPLETED_BEFORE_TARGET = 'COMPLETED_BEFORE_TARGET',
  COMPLETED_WITH_TARGET_UPDATES = 'COMPLETED_WITH_TARGET_UPDATES'
}

export const batchStatusList = [
  BatchStatusEnum.COMPLETED,
  BatchStatusEnum.CONCLUDED,
  BatchStatusEnum.CANCELLED,
  BatchStatusEnum.IN_OPERATION,
  BatchStatusEnum.STOPPED,
  BatchStatusEnum.LOADING,
  BatchStatusEnum.COMPLETED_BEFORE_TARGET,
  BatchStatusEnum.COMPLETED_WITH_TARGET_UPDATES
] as const;

export type BatchStatus = (typeof batchStatusList)[number];
